//process api responses

import axios from "axios"
import {getServiceTypeFromProductConfig} from "./configuration"
import {SHARED_HOSTING_TYPE} from "./servicetype"
import {ERR_SERVICE_EXISTS, INFO_PROMO_REMOVED} from "./common"

export const getDataFromSuccessResponse = (response) => {
    //get sanitised data from success response
    const { data } = response
    let returnedData = null
    if (data && data.data) {
        returnedData = data.data
        if (data.message && returnedData && typeof returnedData === 'object') {
            returnedData.message = data.message
        }
    } else {
        returnedData = data
    }
    return returnedData
}

export const getErrorFromFailResponse = (error) => {
    // add some details if it's cancelled by Axios
    let returnedData = null
    if (axios.isCancel(error)) {
        const response = {}
        response.data = {}
        response.data.errors = []
        response.data.errors[0] = {
            details: 'Response Cancelled'
        }
        returnedData = response
        return returnedData
    }
    let { response } = error
    if (response && response.status) {
        if (response.status === 400) {
            returnedData = response
        } else if (response.status === 401) {
            const { data } = response
            const { code } = data
            switch (code) {
                case 'ERR_ACTIVATION_TOKEN_ACTIVATED':
                    response.data.errors = []
                    response.data.errors[0] = {
                        details: 'You account has been activated.'
                    }
                    break

                case 'ERR_ACTIVATION_TOKEN_EXPIRED':
                    response.data.errors = []
                    response.data.errors[0] = {
                        details: 'This link is expired. Please contact the owner account to re-invite and activate your account.'
                    }
                    break

                default:
                    if (!response.data.errors[0].details) {
                        response.data.errors = []
                        response.data.errors[0] = {
                            details: 'Your authentication details are invalid. Please re-check the confirmation code, token, and etc or contact our support team if you believe this is not true'
                        }
                    }
                    break
            }
            returnedData = response
        } else if (response.status === 403) {
            response.data.errors = []
            response.data.errors[0] = {
                details: 'You don\'t have enough privilege to access this information. Please contact our support team if you believe this is not true.'
            }
            returnedData = response
        } else {
            const fataError = {
                data: {}
            }
            fataError.data.errors = []
            fataError.data.errors[0] = {
                details: 'Something\'s gone wrong. Please try again later or contact our support team.'
            }
            returnedData = fataError
        }
    } else {
        const fataError = {
            data: {}
        }
        fataError.data.errors = []
        fataError.data.errors[0] = {
            details: 'Something\'s gone wrong. Please try again later or contact our support team.'
        }
        returnedData = fataError
    }
    return returnedData
}

export const getMetaFromSuccessResponse = (response) => {
    //get sanitised meta data from success response
    let returnedData = null
    if(response && response.data){
        const { meta } = response.data
        if (meta) {
            returnedData =meta
        }
    }
    if(typeof response.meta !== "undefined"){
        returnedData = response.meta
    }
    return returnedData
}

export const isResponseCancelled = (errorData) => {
    //check if the error is caused by "Axios Cancel" function
    const { data } = errorData
    const { errors } = data
    let isCancelled = false
    if (errors && errors.length > 0) {
        isCancelled = errors.some(e => e.details === 'Response Cancelled')
    }
    return isCancelled
}

export const errorMessagesModifier = (productConfig,errorData) => {
    //custom error messages when adding a service that already exist in our system
    if(errorData && errorData.data &&
        errorData.data.code && window.app_config &&
        window.app_config.upgrade_web_hosting_faq_link){
        const {code} = errorData.data
        const {upgrade_web_hosting_faq_link} = window.app_config
        if(code===ERR_SERVICE_EXISTS){
            const productType = getServiceTypeFromProductConfig(productConfig)
            if(productType===SHARED_HOSTING_TYPE){
                const message = new Array({
                    details: `Looks like there might be an active hosting service for that domain already. If you're looking to upgrade, check out information on <a target="_blank" href="${upgrade_web_hosting_faq_link}">upgrading your service</a>`,
                    status: 400
                })
                errorData.data.errors = message
            }
        }
    }
    return errorData
}

export const isPromoRemovedFromResponse = (response) => {
    //check if the error response is about promo removal
    if(response && response.data && response.data.code){
        const {code} = response.data
        const showList = new Array(INFO_PROMO_REMOVED)
        return showList.find(i=>i===code)
    }
    return null
}